module.exports = __webpack_public_path__ + "static/media/goodnest_app5.d176bfb2.jpg";